<div
  class="calendar-loader"
  [ngStyle]="{ display: isCalendarLoading ? 'flex' : 'none' }"
  role="status"
  [attr.aria-label]="'Loading calendar'"
>
  <app-loader />
</div>

@if (!isCalendarLoading) {
  <div
    class="week-days"
    role="application"
    [attr.aria-label]="'Calendar'"
  >
    <!--Calendar subheader week days in shot form (Mo, Tu)-->
    <ng-template #shortDaysHeaderTemplate>
      <div class="cal-cell-row cal-header" role="rowgroup">
        @for (day of columnHeaders | slice:0:7; track day) {
          <div
            class="cal-cell"
            [class.cal-past]="day.isPast"
            [class.cal-today]="day.isToday"
            [class.cal-future]="day.isFuture"
            [class.cal-weekend]="day.isWeekend"
            [ngClass]="day.cssClass"
            role="columnheader"
            [attr.aria-label]="'calendar_component.day' + day.date.getDay() | translate"
          >
            {{ "calendar_component.day" + day.date.getDay() | translate }}
          </div>
        }
      </div>
    </ng-template>
    <!-- Calendar cell -->
    <ng-template #customCellTemplate let-day="day" let-lang="lang">
      <div class="cal-cell-top" role="gridcell">
        @if (day.cssClass !== 'cal-disabled') {
          <span
            class="cal-day-number text-center"
            (click)="onSelectDay(day)"
            role="button"
            [attr.aria-label]="(day.date | calendarDate : 'monthViewDayNumber' : lang) + ' ' + (day.date | date : 'MMMM y')"
            [attr.aria-selected]="day.cssClass === 'cal-selected'"
            [attr.aria-disabled]="day.cssClass === 'cal-disabled'"
            tabindex="0"
          >
            {{ day.date | calendarDate : "monthViewDayNumber" : lang }}
            @if (day.badgeTotal > 0 && day.cssClass === 'cal-selected') {
              <span
                class="badge badge-primary custom-selected-date-slots-badge"
                [ngClass]="{
                  'selected-date-single-digit-badge-adjustment': (day.date | calendarDate : 'monthViewDayNumber' : lang) < 10,
                  'selected-date-double-digit-badge-adjustment': (day.date | calendarDate : 'monthViewDayNumber' : lang) >= 10
                }"
                role="status"
                [attr.aria-label]="day.badgeTotal + ' slots available'"
              >{{ day.badgeTotal }}</span>
            } @if (day.badgeTotal > 0 && day.cssClass === 'cal-selected-without-highlight') {
              <span
                class="badge badge-primary custom-slots-badge-without-highlighting"
                [ngClass]="{
                  'without-highlight-single-digit-badge-adjustment': (day.date | calendarDate : 'monthViewDayNumber' : lang) < 10,
                  'without-highlight-double-digit-badge-adjustment': (day.date | calendarDate : 'monthViewDayNumber' : lang) >= 10
                }"
                role="status"
                [attr.aria-label]="day.badgeTotal + ' slots available'"
              >{{ day.badgeTotal }}</span>
            }
          </span>
        }
        @if (day.cssClass === 'cal-disabled') {
          <span
            class="cal-day-number text-center disabled-day"
            role="button"
            [attr.aria-label]="(day.date | calendarDate : 'monthViewDayNumber' : lang) + ' ' + (day.date | date : 'MMMM y') + ' - Not available'"
            [attr.aria-disabled]="true"
            tabindex="0"
          >
            {{ day.date | calendarDate : "monthViewDayNumber" : lang }}
          </span>
        }
      </div>
    </ng-template>
    <!-- Calendar Header -> Previous button, Month & Title year and Next button-->
    <div
      class="btn-group d-flex calendar-header justify-content-between align-items-center custom-calendar-header"
      role="toolbar"
      [attr.aria-label]="'Calendar navigation'"
    >
      <button
        class="btn btn-link calendar-header-title"
        [ngClass]="{ 'disable-button': prevBtnDisabled }"
        mwlCalendarPreviousView
        view="month"
        [disabled]="prevBtnDisabled"
        (click)="decrement()"
        role="button"
        [attr.aria-label]="'Previous month'"
      >
        <img
          class="calendar-icons"
          src="{{ imagePath }}/chevron-left-solid.svg"
          alt="Previous month"
        />
      </button>
      <div
        class="btn btn-link calendar-header-title disabled"
        role="heading"
        aria-level="2"
        [attr.aria-label]="(viewDate | date : 'MMMM') + ' ' + (viewDate | date : 'y')"
      >
        <div class="calendar-header-button-text text-overflow-center">
          <div>{{ viewDate | date : "MMMM" | translate }}</div>
          <div>{{ viewDate | date : "y" }}</div>
        </div>
      </div>
      <button
        class="btn btn-link calendar-header-title"
        [ngClass]="{ 'disable-button': nextBtnDisabled }"
        mwlCalendarNextView
        view="month"
        [disabled]="nextBtnDisabled"
        (click)="increment()"
        role="button"
        [attr.aria-label]="'Next month'"
      >
        <img
          class="calendar-icons"
          src="{{ imagePath }}/chevron-right-solid.svg"
          alt="Next month"
        />
      </button>
    </div>
    <div role="grid" [attr.aria-label]="(viewDate | date : 'MMMM') + ' ' + (viewDate | date : 'y')">
      <mwl-calendar-month-view
        [viewDate]="viewDate"
        [weekStartsOn]="1"
        [headerTemplate]="shortDaysHeaderTemplate"
        [refresh]="updateCalendarState"
        [cellTemplate]="customCellTemplate"
        (beforeViewRender)="beforeMonthViewRender($event)"
      />
    </div>
  </div>
}


@if (bookingService.partnerData?.is_timezone_enabled) {
  <div class="mt-20 mb-2 cbsw-timezone-wrapper">
    @if (bookingService.partnerData?.widget_display_timezone_source !== widgetDisplayTimezoneSource.PARTNER || !bookingService.partnerData?.timezone) {
      <label class="fw-semibold cbsw-timezone-label">
        {{ "booking_components.timezone" | translate }}:
      </label>
    }
    <app-timezone-select
      [timezones]="timezones"
      (onTimezoneChange)="onTimezoneChangeEvent.emit($event)"
    />
  </div>
}